var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4935 9.63451C22.0935 3.47451 16.7201 0.701172 12.0001 0.701172C12.0001 0.701172 12.0001 0.701172 11.9868 0.701172C7.28013 0.701172 1.89346 3.46117 0.49346 9.62117C-1.06654 16.5012 3.14679 22.3278 6.96013 25.9945C8.37346 27.3545 10.1868 28.0345 12.0001 28.0345C13.8135 28.0345 15.6268 27.3545 17.0268 25.9945C20.8401 22.3278 25.0535 16.5145 23.4935 9.63451ZM12.0001 16.3145C9.68013 16.3145 7.80013 14.4345 7.80013 12.1145C7.80013 9.79451 9.68013 7.91451 12.0001 7.91451C14.3201 7.91451 16.2001 9.79451 16.2001 12.1145C16.2001 14.4345 14.3201 16.3145 12.0001 16.3145Z",
    fill: "#0059AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLocation);
export default __webpack_public_path__ + "static/media/blue-location.4589fa25ea8c8b3794ce5391ff69b69d.svg";
export { ForwardRef as ReactComponent };